import React, { useState } from 'react';
import { apiFetch } from '../utils/api';
import { Helmet } from 'react-helmet-async';
import '../styles/Contact.css';
import '../styles/_colors.css';
import '../styles/_typography.css';
import '../styles/main.css';

function validateEmail(email) {
  // Simple RFC 5322 compliant regex for email validation
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
}

function sanitizeInput(input) {
  // Remove script tags and encode angle brackets
  return input
    .replace(/<script.*?>.*?<\/script>/gi, '')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/["']/g, ''); // Remove quotes for extra safety
}

export default function Contact() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: '',
    message: '',
  });
  const [status, setStatus] = useState('');

  const handleChange = e => {
    setFormData(prev => ({ ...prev, [e.target.name]: e.target.value }));
  };

  const handleSubmit = async e => {
    e.preventDefault();

    // Validate email format
    if (!validateEmail(formData.email)) {
      setStatus('Please enter a valid email address.');
      return;
    }

    // Sanitize all fields
    const safeData = {
      name: sanitizeInput(formData.name),
      email: sanitizeInput(formData.email),
      subject: sanitizeInput(formData.subject),
      message: sanitizeInput(formData.message),
    };

    try {
      const data = await apiFetch('/api/contact-new', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(safeData),
      });

      if (data.success) {
        setStatus('Message sent securely!');
        setFormData({ name: '', email: '', subject: '', message: '' });
      } else {
        setStatus(data.message || 'Failed to send message.');
      }
    } catch (err) {
      console.error('Contact submission error:', err);
      setStatus('Failed to send message. Please try again later.');
    }
  };

  return (
    <div className="contact-form-container">
      <Helmet>
        <title>NHHS Analytics | Contact</title>
      </Helmet>
      <h2>Contact Us</h2>
      <form className="contact-form" onSubmit={handleSubmit} autoComplete="off">
        <input
          name="name"
          type="text"
          placeholder="Your Name"
          required
          onChange={handleChange}
          value={formData.name}
          autoComplete="off"
        />
        <input
          name="email"
          type="email"
          placeholder="Your Email"
          required
          onChange={handleChange}
          value={formData.email}
          autoComplete="off"
        />
        <input
          name="subject"
          type="text"
          placeholder="Subject"
          required
          maxLength={100} // Limit subject length
          onChange={handleChange}
          value={formData.subject}
          autoComplete="off"
        />
        <textarea
          name="message"
          rows="5"
          placeholder="Your Message"
          required
          onChange={handleChange}
          value={formData.message}
          autoComplete="off"
        ></textarea>
        <button type="submit">Send Message</button>
        {status && (
          <div
            style={{
              marginTop: '1.2rem',
              textAlign: 'center',
              color:
                status === 'Message sent securely!'
                  ? 'var(--color-button-bg)'
                  : '#c00',
              fontWeight: 500,
              fontSize: '1.1rem',
              letterSpacing: '0.01em',
            }}
          >
            {status}
          </div>
        )}
      </form>
    </div>
  );
}
